import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import { AuthHydrationGate } from '@/app/AuthHydrationGate';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <AuthHydrationGate>
        <RouterProvider router={router} />
      </AuthHydrationGate>
    </AppProviders>
  </StrictMode>,
);
